<kendo-appbar position="top" class="container">
  <div class="container__head">
    <kendo-appbar-section>
      <button class="k-button k-button-clear" (click)="toggleMenu($event)">
        <kendo-icon id="burgerIcon" name="menu"></kendo-icon>
      </button>
    </kendo-appbar-section>
    <kendo-appbar-section>
      <a class="container__logo" [routerLink]="['/']">
        <img src="./assets/images/logo.png" />
      </a>
    </kendo-appbar-section>
  </div>

  <div class="container__tail">
    <kendo-appbar-section
      class="actions"
      *ngIf="currentUser$ | async as currentUser"
    >
      <kendo-avatar
        kendoPopoverAnchor
        [popover]="userPOpover"
        class="container__avatar"
        [imageSrc]="currentUser?.picture ?? ''"
      >
      </kendo-avatar>
      <div class="container__user-name">{{ currentUser.email }}</div>
    </kendo-appbar-section>

    <kendo-appbar-section class="actions">
      <div kendoTooltip>
        <button
          class="k-button k-button-clear"
          (click)="logout()"
          title="Logout"
        >
          <kendo-icon name="logout"></kendo-icon>
        </button>
      </div>
    </kendo-appbar-section>
  </div>
</kendo-appbar>

<kendo-popover #userPOpover position="bottom" [width]="250" [callout]="false">
  <ng-template kendoPopoverBodyTemplate>
    <div class="popover">
      <div class="popover__wrap">
        <span class="popover__label">First Name:</span>
        <span class="popover__value">{{
          (currentUser$ | async)?.firstName
        }}</span>
      </div>
      <div class="popover__wrap">
        <span class="popover__label">Last Name:</span>
        <span class="popover__value">{{
          (currentUser$ | async)?.lastName
        }}</span>
      </div>
      <div class="popover__wrap">
        <span class="popover__label">Roles:</span>
        <span class="popover__value">{{
          (currentUser$ | async)?.roles | rolesPipe
        }}</span>
      </div>
      <!-- <div class="popover__wrap">
        <span class="popover__label">Permissions:</span>
        <span class="popover__value">{{
          (currentUser$ | async)?.permissions
        }}</span>
      </div> -->
    </div>
  </ng-template>
</kendo-popover>
